module.exports = __webpack_public_path__ + "img/scene5-11.12f3a4f3.jpg";